import { createSlice } from '@reduxjs/toolkit';
import {
  getCoursesInInstitution,
  getPaginatedEnrolments,
  getPaginatedPendingInvitations,
} from './asyncActions';
import { INITIAL_STATE } from './state';
import { AsyncState, CourseEnrolment } from './types';

export const institutionAdminSettingsSlice = createSlice({
  name: 'institutionAdminSettings',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaginatedEnrolments.pending, (state) => {
        state.paginatedInstitutionEnrolments.asyncState = AsyncState.LOADING;
      })
      .addCase(getPaginatedEnrolments.fulfilled, (state, action) => {
        const { payload } = action;
        if (payload) {
          const {
            enrolments,
            total,
            hasNextPage,
            hasPrevPage,
            totalPages,
          } = payload;
          state.paginatedInstitutionEnrolments = {
            asyncState: AsyncState.SUCCESS,
            enrolments,
            total,
            hasNextPage,
            hasPrevPage,
            totalPages,
          };
        }
      })
      .addCase(getPaginatedEnrolments.rejected, (state) => {
        state.paginatedInstitutionEnrolments.asyncState = AsyncState.FAILED;
      })
      .addCase(getPaginatedPendingInvitations.pending, (state) => {
        state.paginatedPendingInvitations.asyncState = AsyncState.LOADING;
      })
      .addCase(getPaginatedPendingInvitations.fulfilled, (state, action) => {
        const { payload } = action;
        if (payload) {
          state.paginatedPendingInvitations = {
            asyncState: AsyncState.SUCCESS,
            ...payload,
          };
        }
      })
      .addCase(getPaginatedPendingInvitations.rejected, (state) => {
        state.paginatedPendingInvitations.asyncState = AsyncState.FAILED;
      })
      .addCase(getCoursesInInstitution.pending, (state) => {
        state.coursesFilterData.asyncState = AsyncState.LOADING;
      })
      .addCase(getCoursesInInstitution.fulfilled, (state, action) => {
        const { payload: courses } = action;
        if (courses) {
          const newAllCourses: { [coursePath: string]: CourseEnrolment } = {};
          courses.sort((a, b) => a.name.localeCompare(b.name));
          courses.forEach((course) => {
            newAllCourses[course.path] = course;
          });
          state.coursesFilterData = {
            asyncState: AsyncState.SUCCESS,
            allCourses: newAllCourses,
          };
        }
      })
      .addCase(getCoursesInInstitution.rejected, (state) => {
        state.coursesFilterData.asyncState = AsyncState.FAILED;
      });
  },
});

export const InstitutionAdminSettings = institutionAdminSettingsSlice.reducer;
